import { Form } from "react-router-dom";

import { PROJECT_STATUSES } from "@/app/projects/constants";
import { Button } from "@/components/clickable";
import AuthorizeGate from "@/modules/authorize/gate";
import getPath from "@/modules/get-path";
import Header from "../header";
import Details from "./details";
import { useUnprocessedProjectProvider } from "./provider";
import StatementsTable from "./statements-table";

const labels = {
  [PROJECT_STATUSES.failed]: "Failed - Contact support",
  [PROJECT_STATUSES.processing]: "Processing...",
};

export default function UnprocessedView() {
  const { isDisabled, status, setIsPooling, pooling, project, metadata } =
    useUnprocessedProjectProvider();

  if (!pooling.statements || pooling.statements.items.length === 0) {
    return <></>;
  }

  return (
    <>
      <Header project={pooling.project}>
        <AuthorizeGate>
          <Form
            method="put"
            action={getPath(project, "/process")}
            onSubmit={() => setIsPooling(true)}
          >
            <Button type="submit" disabled={isDisabled}>
              {labels[status] || "Process project"}
            </Button>
          </Form>
        </AuthorizeGate>
      </Header>
      <Details
        project={pooling.project}
        statements={pooling.statements}
        metadata={metadata}
      />
      <StatementsTable />
    </>
  );
}
